export default __webpack_public_path__ + "static/Image080-eeaa3a500ae7d8c3f76eeaca9ca2ba21.png";